import Ajv from 'ajv'
import { createContext, useContext } from 'react'
import type { EffectiveSchemaBridge, FieldError } from '../schema/EffectiveSchemaBridge'

export interface FormContextValue {
  bridge: EffectiveSchemaBridge
  model: Record<string, unknown>
  onChange: (name: string, value: unknown) => void
  onSubmit: () => void
  errors: FieldError[]
  /** Ajv instance used for schema evaluation */
  ajv?: Ajv
  /** Warnings keyed by field path */
  warnings: Record<string, string>
  /** Which fields have been interacted with */
  touched: Record<string, boolean>
  /** Mark a field as touched */
  touch: (name: string) => void
  submitted: boolean
  submitting: boolean
  disabled: boolean
  readOnly: boolean
  showInlineError: boolean
  /** Current field name prefix for nested contexts */
  namePrefix: string
}

export const FormContext = createContext<FormContextValue | null>(null)

export function useFormContext(): FormContextValue {
  const ctx = useContext(FormContext)
  if (!ctx) {
    throw new Error('useFormContext must be used within an EffectiveAutoForm')
  }
  return ctx
}
